import { FC } from 'react';
import paulinaAvatar from '@assets/images/paulina-avatar.jpg';
import { V4, Z } from '@components/v4';

/**
 * PaulinaPill — entrada de Paulina en DESKTOP (Opción A). Pill NOMBRADA (avatar +
 * "Paulina") anclada abajo-derecha, z-index `Z.paulinaPill` (80, SIEMPRE por debajo
 * del toast de pedido `Z.pedido`=99 en NotificationCenterV2). Se OCULTA por completo
 * (no render) cuando hay un pedido entrante — lo operativo gana.
 *
 * El `data-press` lo usa el design system V4 para el micro-feedback de presión.
 * Proactividad (dot verde + speech-bubble) suprimida cuando hay pedido; el dot
 * (`V4.accentMint`, SOLO dot sin texto — WCAG) se monta aquí solo cuando hay un nudge
 * pendiente y NO hay pedido. El hover-scale se desactiva con `motion-reduce`.
 */

interface PaulinaPillProps {
  hasNudge: boolean;
  onOpen: () => void;
}

export const PaulinaPill: FC<PaulinaPillProps> = ({ hasNudge, onOpen }) => (
  <button
    type="button"
    data-press
    aria-label="Abrir chat con Paulina"
    onClick={onOpen}
    style={{ background: V4.primary, color: V4.white, zIndex: Z.paulinaPill }}
    className="fixed bottom-6 right-6 flex items-center gap-2.5 rounded-full py-2 pl-2 pr-4 shadow-xl transition-transform duration-200 hover:scale-105 motion-reduce:transition-none motion-reduce:hover:scale-100"
  >
    <span className="relative inline-flex">
      <img
        src={paulinaAvatar}
        alt=""
        aria-hidden="true"
        className="h-9 w-9 rounded-full object-cover"
        style={{ border: `2px solid ${V4.secondary}` }}
      />
      {hasNudge && (
        <span
          aria-hidden="true"
          className="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full"
          style={{ background: V4.accentMint, border: `2px solid ${V4.primary}` }}
        />
      )}
    </span>
    <span className="text-sm font-semibold leading-none">Paulina</span>
  </button>
);
